
import clienteAxios from "../config/axios";

export const getAllChecklists = async () => {
    return clienteAxios.get('/checklist');
};
export const getChecklistsAllowed = async (ids) => {
    return clienteAxios.post('/checklistAllowed', {ids});
};
export const addChecklist = async (checklist) => {
    return await clienteAxios.post('/checklist',{checklist});
}
export const updateChecklist = async (checklist) => {
    return await clienteAxios.put(`checklist/${checklist._id}`,{updates:checklist});
}
export const deleteChecklist = async (checklist) => {
    return await clienteAxios.delete(`checklist/${checklist._id}`);
}
export const getChecklistByID = async(checkID) =>{
    return clienteAxios.get(`/checklist/${checkID}`);
}
export const addFiles = async(formData) => {
    return clienteAxios.post("/checklist/file", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}
export async function deleteFilesByCampoAndCk(ckCod, campo){
    return clienteAxios.delete(`/checklist/files/${ckCod}/${campo}`);
}


/*Checklist Registros*/
export const getAllChecklistsReg = async () => {
    return clienteAxios.get('/checklistReg');
};
export const getAllChecklistsRegByFilter = async (userId, filtros) => {
    return clienteAxios.get(`/checklistReg/byFilter/${userId}${filtros}`);
};
export const addChecklistReg = async (checklistReg) => {
    return await clienteAxios.post('/checklistReg',{checklistReg});
}
export const updateChecklistReg = async (checklist) => {
    return await clienteAxios.put(`/checklistReg/${checklist._id}`,{updates:checklist});
}
export const endChecklistReg = async (checklist,user) => {
    return await clienteAxios.put(`/checklistReg/end/${checklist._id}`,{updates:checklist, usuario:user});
}
export const getChecklistRegByID = async(ckRegID) => {
    return clienteAxios.get(`/checklistReg/getChekReg/${ckRegID}`);
}
//Obtiene las ordenes de trabajo, pendientes o en progreso, que tienen este checklist asociado.
export const getChecklistCorriendoByActivoID = async(activoId) =>{
    return clienteAxios.get(`/checklistReg/${activoId}`);
}
//Obtiene las ordenes de trabajo, pendientes o en progreso, que tienen este checklist asociado.
export const getTDocsAssociated = async(checkID,activoID) =>{
    return clienteAxios.get(`/transactionDocument/getTDocsWithCKAssociated/${checkID}/${activoID}`);
}

export const associateNroCheckToODT = async(relationID, checkNro) =>{
    return clienteAxios.post(`/transactionDocument/associateCKtoTDoc`, {relationID, checkNro});
}

export const getChecklistRegFiles = async (prefijo) => {
    return clienteAxios.get(`/checklistReg/file/${prefijo}`);
}

